const routes = [
    {
        path: "/course/agreement-form",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "courseagreement_studentform"
        }
    }
]

export default routes;
